import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { CollabCodeEditorModule } from '@portal-core/code-editor/components/collab-code-editor/collab-code-editor.module';
import { CollabDocBarModule } from '@portal-core/collab/components/collab-doc-bar/collab-doc-bar.module';
import { FlareTextEditorModule } from '@portal-core/project-files/components/flare-text-editor/flare-text-editor.module';
import { ProjectFilesAccessErrorMessageModule } from '@portal-core/project-files/components/project-files-access-error-message/project-files-access-error-message.module';
import { FlareCollabEditorComponent } from './flare-collab-editor.component';

@NgModule({
  declarations: [
    FlareCollabEditorComponent
  ],
  imports: [
    CollabCodeEditorModule,
    CollabDocBarModule,
    CommonModule,
    FlareTextEditorModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    ProjectFilesAccessErrorMessageModule
  ],
  exports: [
    FlareCollabEditorComponent
  ]
})
export class FlareCollabEditorModule { }
